import EditDelete from './EditDelete';

export default EditDelete;
